import React, { useState, useEffect } from "react";
import "./hamburger.css";
import logo from "../../assets/imgs/navbar_img/logoRBS.png";
import lg_facebook from "../../assets/imgs/navbar_img/lg_facebook.png";
import lg_instagram from "../../assets/imgs/navbar_img/lg_instagram.png";
import lg_twitter from "../../assets/imgs/navbar_img/X_Twitter_Logo.svg";
import lg_youtube from "../../assets/imgs/navbar_img/lg_youtube.png";
import lg_Tiktok from "../../assets/imgs/navbar_img/tiktok_logo_icon.svg";
import navbar_line from "../../assets/imgs/navbar_img/navbar_line.png";
import menu_movil from "../../assets/imgs/navbar_img/Menu_movil.png";
import { useTranslation } from "react-i18next";
import lg_search from "../../assets/imgs/navbar_img/lg_search.png";
import Modal2 from "../../components/modalSus/ModalSus";

const Hamburger = () => {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);

  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  // const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
  const [langText, setLangText] = useState(
    lang === "es" ? "English" : "Spanish"
  );
  const [t, i18n] = useTranslation("global");
  const [inputVal, setInputVal] = useState("");

  const [popup, setPopup] = useState(false);
  useEffect(() => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  }, [lang]);

  const changeLanguage = () => {
    const newLang = lang === "es" ? "en" : "es";
    setLang(newLang);
    setLangText(newLang === "es" ? "English" : "Spanish");
    setHamburgerOpen((prev) => !prev);
  };

  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const openModal2 = () => {
    setIsModalOpen2(true);
  };

  const closeModal2 = () => {
    setIsModalOpen2(false);
  };

  const handleInputChange = (event) => {
    setInputVal(event.target.value);
  };

  const handleClick = () => {
    if (inputVal != null && inputVal != "") {
      window.location.href = "/es/busqueda/" + inputVal;
    }
  };

  const handleKeyDown = (e) => {
    // Verificar si la tecla presionada es "Enter" (código 13)
    if (e.key === "Enter") {
      handleClick();
    }
  };

  useEffect(() => {
    if (hamburgerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [hamburgerOpen]);

  const clearSearch = () => {
    setInputVal('');
  };

  return (
    <div>
      <div
        className={`HB_navbar_movil_logo${hamburgerOpen ? "_hide" : "_show"}`}
      >
        <a href="/">
          <img
            className="HB_navbar_logorbs_movil"
            alt="RBS Logo"
            src={"/assets/svg/Logo RBS mobile.svg"}
          />
        </a>
      </div>
      <button
        className="HB_navbar_movil_bt"
        onClick={() => setHamburgerOpen((prev) => !prev)}
      >
        {!hamburgerOpen && (
          <img className="navbar_movil_toggle" src={menu_movil} />
        )}
        {hamburgerOpen && (
          <img
            className="navbar_movil_toggle"
            src={"/assets/svg/Close_button.svg"}
          />
        )}
      </button>
      <div className={`HB_menu${hamburgerOpen ? "_show" : "_hide"}`}>
        <div className="HB_navbar_Logo">
          <a href="/">
            <img
              className="HB_navbar_logorbs"
              alt="RBS Logo"
              src={"/assets/svg/Logo RBS mobile.svg"}
            />
          </a>
        </div>
        <div className="HB_navbar_redessociales">
          <a
            href="https://www.youtube.com/channel/UCovDaTdisIRpyFqQsNGMNsQ"
            target="_blank"
            className="HB_navbar_bt"
          >
            <img className="navbar_yt" src={lg_youtube} />
          </a>
          <a
            href="https://twitter.com/ricardobsalinas"
            target="_blank"
            className="HB_navbar_bt"
          >
            <img className="navbar_tw" src={lg_twitter} />
          </a>
          <a
            href="https://www.facebook.com/RicardoSalinasPliego"
            target="_blank"
            className="HB_navbar_bt"
          >
            <img className="navbar_fb" src={lg_facebook} />
          </a>
          <a
            href="https://www.instagram.com/ricardosalinas/?hl=es-la"
            target="_blank"
            className="HB_navbar_bt"
          >
            <img className="navbar_insta" src={lg_instagram} />
          </a>
          <a
            href="https://www.tiktok.com/discover/ricardo-salinas-pliego?lang=es"
            target="_blank"
            className="HB_navbar_bt"
          >
            <img className="navbar_insta" src={lg_Tiktok}  style={{width:'30px'}}/>
          </a>
        </div>

        <div className="HB_navbar_line">
          <img src={navbar_line} />
        </div>

        <div className="HB_navbar_menu">
          <a href={`/${lang}/Sobre-mi`} className="textstyle">
            {t("navbar.sobre-mi")}
          </a>
          <a href={`/${lang}/Ideas-en-Corto`} className="textstyle">
            {t("navbar.ideas-corto")}
          </a>
          <a href={`/${lang}/Ideas-en-libertad`} className="textstyle">
            {t("navbar.ideas-libertad")}
          </a>
          <a href={`/${lang}/biblioteca`} className="textstyle">
            {t("navbar.biblioteca")}
          </a>
        </div>

        <div className="HB_navbar_line">
          <img src={navbar_line} />
        </div>

        <div className="HB_navbar_extras">
          <div className="div_search_nav">
            <input
              type="text"
              placeholder={t("navbar.buscador2")}
              value={inputVal}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            {inputVal && (
                <button
                  onClick={clearSearch}
                  style={{
                    position: 'absolute',
                    right: '55px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: '#888',
                  }}
                >
                  &#x2715; {/* Esto es el símbolo de "X" */}
                </button>
              )}
            <img src={lg_search} onClick={handleClick} />
          </div>
          {/* 
                    <button className="HB_navbar_suscribirse" onClick={(e) => {
                        e.preventDefault();
                        setPopup(true)
                    }}  >{(t('general.suscribirse'))}

                    </button> */}

          <button
            className="HB_navbar_suscribirse"
            onClick={() => openModal2()}
          >
            {t("general.suscribirse")}
          </button>
          {/* {popup && <Suscribir popup={popup} setPopup={setPopup} />} */}

          <a className="HB_navbar_extraitem textstyle" onClick={changeLanguage}>
            {langText}
          </a>
        </div>
      </div>

      <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
    </div>
  );
};

export default Hamburger;
